import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth, hasModuleAccess, hasRole } from "../lib/auth";

const FULL_ROLES = [
  "admin",
  "accounts",
  "hk_supervisor",
  "hk_staff",
  "laundry",
  "front_office",
];
const ASSET_SETTINGS_ROLES = ["admin", "accounts", "hk_supervisor"];
const MAINT_ROLES = ["admin", "accounts", "hk_supervisor", "maintenance"];

const SUB = [
  { to: "/assets/master", label: "Item Master", roles: FULL_ROLES },
  { to: "/assets/rooms", label: "Room & Department Assets", roles: FULL_ROLES },
  { to: "/assets/transfers", label: "Transfers", roles: FULL_ROLES },
  { to: "/assets/maintenance", label: "Maintenance", roles: MAINT_ROLES },
  { to: "/assets/warranty", label: "Warranty & AMC", roles: MAINT_ROLES },
  { to: "/assets/reports", label: "Reports", roles: FULL_ROLES },
  { to: "/assets/settings", label: "Settings", roles: ASSET_SETTINGS_ROLES },
];

export default function AssetNav() {
  const { user } = useAuth();
  const visible = SUB.filter(s => (
    (!s.roles || hasRole(user, ...s.roles))
    && hasModuleAccess(user, "asset_management", "view")
  ));
  return (
    <div className="mb-6 no-print" data-testid="asset-subnav">
      <div className="flex flex-wrap gap-1 border-b border-slate-200 pb-px">
        {visible.map(s => (
          <NavLink
            key={s.to} to={s.to} end
            data-testid={`asset-nav-${s.match || s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={({ isActive }) =>
              `px-3 py-2 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors ${
                isActive ? "border-slate-900 text-slate-900 font-medium" : "border-transparent text-slate-500 hover:text-slate-800"}`}
          >
            {s.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
